<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M41 9v30a2 2 0 01-2 2h-8.54V27.84h4.41l.66-5.13h-5.07v-3.28a2.87 2.87 0 01.54-1.86 2.6 2.6 0 012-.57h2.7v-4.65a28.53 28.53 0 00-3.94-.2A6.6 6.6 0 0027 13.92a6.7 6.7 0 00-1.8 5v3.79h-4.48v5.13h4.43V41H9a2 2 0 01-2-2V9a2 2 0 012-2h30a2 2 0 012 2z"/></svg>